/* eslint-disable no-param-reassign */

xplenty.filter('errorFieldName', [
  function () {
    return function (fieldName, indefiniteArticle) {
      indefiniteArticle = typeof indefiniteArticle === 'undefined' ? true : indefiniteArticle;
      const res = fieldName ? fieldName.toLowerCase().replace(/\bid\b/, 'ID') : '';
      if (indefiniteArticle) {
        return (res.match(/^[aeiouAEIOU]/) ? 'an ' : 'a ') + res;
      }
      return res;
    };
  },
]);
